import { isMobile } from "../utils/device-utils";
import isMaster from "./is-master";

export const XOYO_URL = isMaster ? "https://ws.xoyo.com" : "https://test-ws.xoyo.com";

export const CAPTCHA_ZT_PRE_AUTH = isMaster ? "https://ws.xoyo.com/core/captcha/pre_auth" : "https://test-ws.xoyo.com/core/captcha/pre_auth";

export const XOYO_PLATFORM_ADDRESS = isMaster ? "https://pf-api.xoyo.com" : "https://my-api-dev.xoyo.com";

export const PASSPORT_ROOT_ADDRESS = `${XOYO_PLATFORM_ADDRESS}/passport/common_api`;

export const CAPTCHA_PRE_AUTH = `${PASSPORT_ROOT_ADDRESS}/pre_auth`;

// noinspection JSUnresolvedVariable
export const CAPTCHA_XOYO_PIC_URL = `${XOYO_PLATFORM_ADDRESS}/passport/common_api/captcha`;

//xoyo极验
export const CAPTCHA_XOYO_PRE_AUTH = `${PASSPORT_ROOT_ADDRESS}/pre_auth`;

//专题极验
export const CAPTCHA_ZT_PIC_URL = `${XOYO_URL}/core/captcha/create`;

//忘记账号
export const JX3_FORGET_ACCOUNT = "https://kefu.xoyo.com/?r=jx3_recover_account&service_id=950";

//忘记密码
export const FORGET_PASSWORD = isMobile() ? "https://m.xoyo.com/?source=index_top#/forget-password?redirect=%2Fsecurity" : "https://security.xoyo.com/forget-password";

//金山网络服务使用协议
export const SERVICE_AGREEMENT = "https://help.xoyo.com/agreement?name=kingsoft-network-service-agreement";

//金山通行证隐私权政策
export const PRIVACY_POLICY = "https://help.xoyo.com/agreement?name=kingsoft-online-privacy-policy";

//在线客服
export const KEFU_ONLINE = "https://kefurobot.xoyo.com/webchatbot/chat.html?sysNum=1578898069071&sourceId=62211&lang=zh_CN";

//其它登录方式
export const XOYO_SIGNUP = "https://passport.xoyo.com/signup";

//xoyo移动端注册
export const XOYO_REGISTER = isMaster ? "https://m.xoyo.com/#/signup?type=mobile" : "https://m-dev.xoyo.com/passport/signup.html";

//xoyo个人中心
export const XOYO_PERSONAL_CENTER = isMobile() ? "https://m.xoyo.com/?source=index_top#/profile" : "https://i.xoyo.com";
